
import { RatingDto, RatingFormDto } from "@/types/rating.type";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class GradingCardComponent extends Vue {
  @Prop() openRating!: RatingDto;

  form: RatingFormDto = new RatingFormDto();

  get details(): string {
    const parseDateOnly = (v: string | Date): Date => {
      if (v instanceof Date) return v
      const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(v))
      return m ? new Date(+m[1], +m[2] - 1, +m[3]) : new Date(v)
    }

    const date = parseDateOnly(this.openRating.startDateOnly)
    const start = new Date(this.openRating.shiftStartDateTime)
    const end   = new Date(this.openRating.shiftEndDateTime)

    const weekday = date.toLocaleDateString('en-US', { weekday: 'long' })
    const mdy     = date.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' })
    const tOpts: Intl.DateTimeFormatOptions = { hour: 'numeric', minute: '2-digit', hour12: true }

    const startStr = start.toLocaleTimeString('en-US', tOpts)
    const endStr   = end.toLocaleTimeString('en-US', tOpts)

    return `${weekday}, ${mdy} - ${this.openRating.shiftPosition} - ${startStr} - ${endStr}`
  }

  get fullName(): string {
    const t = (s: string): string =>
      s.trim().split(/\s+/).map(p => p.charAt(0).toUpperCase() + p.slice(1).toLowerCase()).join(' ')
    const first = t(this.openRating?.dtFirstName ?? '')
    const last  = t(this.openRating?.dtLastName ?? '')
    return [first, last].filter(Boolean).join(' ')
  }

  save(): void {
    this.form.id = this.openRating.id;

    this.$emit('save', this.form)
  }

  dismiss(): void {
    this.form.id = this.openRating.id;

    this.$emit('dismiss', this.form)
  }
}
